import {
  type InsuranceProviderFormSchema,
  type InsuranceProviderSchema,
  JSONSchemaFieldType,
} from "../../types";
import { genericVisitValidation } from "./shared";

/**
 * Public Insurance
 */
const PublicInsuranceRegistrationSchema: InsuranceProviderFormSchema = {
  title: "Public Insurance details",
  description: "Form definition for Public Insurance details",
  type: JSONSchemaFieldType.OBJECT,
  properties: [
    {
      name: "insuranceNumber",
      title: "Insurance Number (CNIC)",
      type: JSONSchemaFieldType.STRING,
      required: false,
    },
  ],
  orderedProperties: [
    {
      name: "insuranceNumber",
      title: "Insurance Number (CNIC)",
      type: JSONSchemaFieldType.STRING,
      isRequired: false,
    },
  ],
};

export const pakistanInsuranceSchemas: InsuranceProviderSchema[] = [
  {
    id: "Public",
    insuranceType: "Public",
    name: "Public Insurance",
    visitValidation: genericVisitValidation,
    registrationValidation: {
      formSchema: PublicInsuranceRegistrationSchema,
    },
  },
];
